import React, { PureComponent } from "react";
import { noop } from "lodash";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination } from "swiper/modules";
import ContainerLimits from "./styled-components";

export default class ScrollArea extends PureComponent {
  static defaultProps = {
    setSwiper: noop,
    hasPagination: false,
    cardsPerPage: 3,
    contextSA: "topraces",
    isFreeScroll: false,
    customSwiperSlideClass: ""
  };

  computeParams = () => {
    if (!this.props.hasPagination)
      return {
        slidesPerView: "auto",
        modules: [FreeMode, Pagination],
        pagination: { enabled: false },
        autoHeight: true,
        freeMode: this.props.isFreeScroll,
        observer: true,
        observeParents: true,
        observeSlideChildren: true
      };

    return {
      slidesPerView: this.props.cardsPerPage,
      spaceBetween: this.props.contextSA !== "talentpicks" ? 11 : 16,
      modules: [FreeMode, Pagination],
      pagination: { enabled: false }
    };
  };

  render() {
    const params = this.computeParams();
    return (
      <ContainerLimits
        isDesktop={this.props.hasPagination}
        data-qa-label="top-races-scrollAreaContainer"
        contextSA={this.props.contextSA}
      >
        <div>
          <Swiper {...params} onSwiper={this.props.setSwiper}>
            {React.Children.map(this.props.children, (child) => (
              <SwiperSlide
                className={this.props.customSwiperSlideClass}
              >
                {child}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </ContainerLimits>
    );
  }
}
